module.exports = __webpack_public_path__ + "img/about1.da41eba9.png";